import { imgUrl } from '@bww/beke-lib/sanity-client'
import Image from 'next/image'
import styles from './Hero.module.scss'

import classNames from 'classnames'

import Link from 'next/link'

import imagesIcon from '@bww/beke-ui/icons/images.svg'
import chevronIcon from '@bww/beke-ui/icons/chevron-right.svg'
import quoteIcon from '@bww/beke-ui/icons/quote-marks.svg'

import { isKE } from '@bww/beke-lib/site-config'

export default function ProjectHero({
  heroImage,
  title,
  locationName,
  shortDescription,
  numOtherImages,
  featuredComment,
  clientTestimonial,
  showImageViewer,
}) {
  const hasMoreImages = numOtherImages > 0
  return (
    <header className={styles.headerWrapper}>
      {heroImage && (
        <div className={styles.imgWrapper}>
          <Image
            src={imgUrl(heroImage).width(2560).url()}
            alt={heroImage.alt || title}
            style={{ objectFit: 'cover' }}
            priority
            // placeholder={heroImage?.lqip ? 'blur' : undefined}
            // blurDataURL={heroImage?.lqip}
            fill
          />
        </div>
      )}
      <div className={classNames(styles.container, 'container')}>
        <div className={styles.left}>
          <div className={styles.infoPanel}>
            <header className={styles.infoPanel__header}>
              <div className="capText">
                {locationName && (
                  <span className={styles.locationName}>{locationName}</span>
                )}
                {isKE ? 'Kitchen' : 'Bathroom'} Project
              </div>
            </header>
            <div className={styles.infoPanel__contentContainer}>
              <h1 className="h1">{title}</h1>
              {shortDescription && (
                <p className={styles.shortDesc}>{shortDescription}</p>
              )}
            </div>
            <div className={styles.infoPanel__actionContainer}>
              <Link href="/projects" className={styles.backCompleted}>
                <svg width=".9em" height=".9em" viewBox="0 0 256 256">
                  <use href={`${chevronIcon.src}#icon`} />
                </svg>
                More Projects
              </Link>
              {/* <button>Send</button>
              <div>Share</div> */}
            </div>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.buttonWrapper}>
            {hasMoreImages && (
              <button
                className={classNames(styles.viewImagesButton, 'button')}
                onClick={showImageViewer}
              >
                <svg width="1.4em" height="1.4em" viewBox="0 0 256 256">
                  <use href={`${imagesIcon.src}#icon`} />
                </svg>
                View images <span>{numOtherImages + 1}</span>
              </button>
            )}
          </div>
          {featuredComment && (
            <div className={styles.commentContainer}>
              {featuredComment.type !== 'other' && (
                <h2
                  className={classNames(
                    styles.commentContainer__heading,
                    'h5 capText',
                  )}
                >
                  {featuredComment.type} Comment
                </h2>
              )}
              <blockquote
                className={classNames({
                  [styles.noQuote]: featuredComment.type === 'other',
                })}
              >
                {featuredComment.text}
              </blockquote>
              {featuredComment.type === 'customer' && clientTestimonial && (
                <a href="#">read testimonial</a>
              )}
              {featuredComment.type !== 'other' && (
                <svg
                  className={styles.quoteIcon}
                  height={32}
                  viewBox="0 0 256 185"
                >
                  <use href={`${quoteIcon.src}#icon`} />
                </svg>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
